import React from 'react';
import styles from './Steps.module.css';

export interface SubstepConfig {
  substeps: string[];
  currentSubstepIdx?: number;
}

export interface StepsProps {
  steps: string[];
  currentIdx?: number;
  current?: number;
  className?: string;
  substeps?: SubstepConfig[];
  currentSubstepIdx?: number;
  /** Indices of steps that were skipped (never traversed). Skipped wins over done. */
  skippedIdx?: number[];
}

const Steps: React.FC<StepsProps> = ({
  steps,
  currentIdx,
  current,
  className = '',
  skippedIdx,
}) => {
  const activeIdx = currentIdx ?? current ?? 0;
  const skippedSet = React.useMemo(() => new Set(skippedIdx ?? []), [skippedIdx]);

  return (
    <div className={styles.stepsContainer}>
      <div className={`uc-steps ${styles.steps} ${className}`}>
        {steps.map((step, index) => {
          let statusClass = '';
          if (index < activeIdx) {
            statusClass = 'step-done';
          }
          if (index === activeIdx) {
            statusClass = 'step-current';
          }
          if (skippedSet.has(index)) {
            statusClass = 'step-skipped';
          }

          return (
            <div
              key={index}
              className={`uc-step ${statusClass} ${styles.step}`}
              data-step={index + 1}
            >
              <div className={`uc-step_head ${styles.stepHead}`}>
                <div className={`uc-step_line ${styles.stepLine}`}></div>
                <div className={`uc-step_count ${styles.stepCount}`}></div>
              </div>
              <div className={`uc-step_info ${styles.stepInfo}`}>
                <div className={`p-size--sm ${styles.stepName}`}>{step}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Steps;
